<template>
<div class="content_container">
  <el-tabs v-model="activeTab" class="tabs">
    <el-tab-pane label="上传视频" name="tab1">
      <el-scrollbar v-loading="rushStatus">
        <div class="container">
          <div class="tip_text" v-if="getHistory">
            您的视频已发布完成，请勿重复提交。
          </div>
        <div class="upload_video" v-else>
          <el-form ref="form" :model="form" label-width="80px">
            <el-row :gutter="80">
              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="缩略图">
                    <el-upload
                    class="uploadThumbImg"
                    :action="uploadImgUrl"
                    name="file"
                    :headers="uploadHeaders"
                    accept=".jpg,.jpeg,.png"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess">
                    <img v-if="form.file_thumb" :src="form.show_thumb" class="thumbImg">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <div class="el-upload__tip">
                    支持JPG/PNG格式，图片比例1.5：1<br />
                    图片大小不超过1MB
                  </div>
                </el-form-item>
                <el-form-item label="团队名称">
                    <el-input type="text"
                    placeholder="请输团队名称"
                    v-model="form.file_name"></el-input>
                </el-form-item>
                <el-form-item label="团队口号">
                    <el-input 
                        type="textarea" 
                        placeholder="请输入团队口号"
                        rows='4'
                        v-model="form.file_introduce"
                        maxlength="200"
                        show-word-limit>
                        </el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="上传视频">
                  <el-upload
                    class="uploadVideo"
                    drag
                    action="#"
                    :show-file-list="false"
                    :http-request="uploadMutil"
                    accept=".wmv,.asf,.asx,.rm,.rmvb,.mp4,.3gp,.mov,.m4v,.avi,.dat,.mkv,.flv,.vob"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将视频拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">
                      推荐采用mp4、flv格式，可有效缩短审核转码耗时<br />
                      
                    </div>
                    <video class="upload__video" v-show="form.file_url" :src="form.file_url" controls></video>
                    <div class="upload__tip">
                      <el-progress :percentage="uploadVideoProgress" v-show="uploadVideoProgressShow"></el-progress>
                      <!-- <el-progress :percentage="uploadVideoProgress" v-show="uploadVideoProgressStatus"></el-progress> -->
                        
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-button type="primary" class="ors_button" style="margin-top: 30px;" @click="subUpload" v-loading="subUploadStatus">发布</el-button>
          </el-form>
        </div>
      </div>
    </el-scrollbar>
  </el-tab-pane>
</el-tabs>
</div>
</template>

<script>
import OSS from "ali-oss";
export default {
  name:'Video',
  data(){
    return {
      activeTab: 'tab1', //当前tab
      uploadImgUrl:process.env.VUE_APP_API_URL + 'api/uploadThumb',
      uploadVideoProgress:0,
      uploadVideoProgressShow:false,
      uploadVideoProgressStatus:'',
      rushStatus:true,
      getHistory:false,
      aliOssUrl:'https://cima-ballot.oss-cn-shanghai.aliyuncs.com/',
      uploadHeaders:{Authorization:window.localStorage.getItem('token')},
      subUploadStatus:false,
      form: {
        file_thumb: '',
        show_thumb:'',
        file_name:'',
        file_introduce:'',
        file_url:'',
      },

    }
  },
  mounted(){
    this.getMultiHistory();
  },
  methods:{
    getMultiHistory(){
      let that = this;
      this.$API('/api/getMultiHistory','get',{},function(response){
        if(response.code === 200){
          if(response.data !== 1){
            that.getHistory=true;
          }
        }
      },function(){
        that.rushStatus=false;
      });
    },
    handleAvatarSuccess(res){
        if(res.code===200){
          this.form.file_thumb = res.data.thumb_url;
          this.form.show_thumb = process.env.VUE_APP_API_URL + res.data.thumb_url; 
        
        }else{
          this.$error(res.message);
        }
    },
    uploadMutil(a){
      let client = new OSS({
          region: process.env.VUE_APP_REGION,
          //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
          accessKeyId: process.env.VUE_APP_ACCESS_KEY,
          accessKeySecret: process.env.VUE_APP_ACCESS_KEY_SECRET,
          bucket: process.env.VUE_APP_BUCKET_NAME
      });

      try {
        let that = this;
        let uploadOptions = {
          headers: { "x-oss-forbid-overwrite": true },
          progress:function(a){
            if(a<1){
              that.uploadVideoProgressShow = true;
            }else if(a === 1){
              that.uploadVideoProgressStatus='success';
              that.uploadVideoProgressShow = false;
            }
            console.log('uploading ... ',a);
            that.uploadVideoProgress=a * 100;
          },
          //meta是用户自定义的元数据，通过head接口可以获取到object的meta数据。
          // meta: {
          //   year: 2020,
          //   people: 'test'
          // }
        };
        let file_name = (new Date()).valueOf() + a.file.name;
        let result = client.multipartUpload(file_name, a.file, uploadOptions).then(res => {
          console.log('success',res);
          that.form.file_url = that.aliOssUrl + file_name;
        })
        .catch(e => {
          console.log('error',JSON.stringify(e));
          if(e.name === 'FileAlreadyExistsError'){
            this.$error('此文件名称已存在');
          }
        });;
        console.log(result);
        let head = client.head(file_name);
        console.log(head);
      } catch (e) {
        // 捕获超时异常。
        if (e.code === 'ConnectionTimeoutError') {
          this.$error('文件上传超时,请重试');
          console.log("TimeoutError");
          // do ConnectionTimeoutError operation
        }
        console.log('error',e)
      }
    },

    subUpload(){
      if(this.subUploadStatus){
        this.$warning();
        return false;
      }else{
        this.subUploadStatus=true;
      }
      let that = this;
      this.$confirm('请检查无误后点击确定', '一经发布不可修改，确认要发布吗？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(()=>{
        that.subHandle(that);
      }).catch(() => {
        that.subUploadStatus=false;
      });
      
    },
    subHandle(that){
      let _data = this.form;

      if(_data.file_name === ''){
        this.$error('请填写团队名称');
        this.subUploadStatus=false;
      }
      if(_data.file_thumb === ''){
        this.$error('请上传缩略图');
        this.subUploadStatus=false;
      }
      if(_data.file_introduce === ''){
        this.$error('请填写团队口号');
        this.subUploadStatus=false;
      }
      if(_data.file_url === ''){
        this.$error('请上传视频');
        this.subUploadStatus=false;
      }

      this.$API('/api/multiInsert','post',_data,function(response){ 
        if(response.code === 200){
          that.$ok(response.message);
          that.getMultiHistory();
        }else{
          that.$error(response.message);
        }
      },function(){
        that.subUploadStatus=false;
      });
    }
    
  }
}
</script>

<style>
  .upload__video{
    float: left;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: white;
  }
</style>